module.exports = __webpack_public_path__ + "img/85.b8cab671.jpg";